import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const PageHeadingContext = /*#__PURE__*/createContext(undefined);
export const PageHeadingProvider = ({
  headingStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(PageHeadingContext.Provider, {
    value: {
      headingStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `PageHeading` component.
 * Note: The context is only available when the `PageHeading` component is rendered as an ancestor.
 * @returns PageHeadingContext - The context for the `PageHeading` component.
 * @returns PageHeadingContext.headingStyleOverrides - Style overrides to be applied to the `Heading` component.
 */
export const usePageHeadingContext = () => {
  const pageHeadingContext = useContext(PageHeadingContext);
  return pageHeadingContext;
};